export default "https://cdn-static.gokick.com/assets/16eea26e4b02b6fb7531e57480884e04972270e8/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";